import InputLabel, { InputLabelSelect } from "../../components/inputLabel";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import preCadastroActions from "../../redux/preCadastro/actions";
import { StoreState } from "../../redux/reduxTypes";
import { PreCadastroState } from "../../types/state.types";
import { DivisoriaSecao, TituloSecao } from "./styled";

function DadosPessoaisPreCadastro() {
  const dispatch = useDispatch();

  const { dados, dadosIniciais, listaCidades } = useSelector<
    StoreState,
    PreCadastroState
  >((state) => state.preCadastroState);

  const atualizarDadosPreCadastro = useCallback(
    (dadosForm: object) => {
      dispatch(
        preCadastroActions.setDados({
          ...dados,
          ...dadosForm,
        })
      );
    },
    [dados, dispatch]
  );

  const buscarCidades = useCallback(
    (uf: string) => {
      dispatch(preCadastroActions.buscarCidades(uf));
    },
    [dispatch]
  );

  return (
    <DivisoriaSecao>
      <TituloSecao>Dados Pessoais</TituloSecao>

      <InputLabel
        labelText="Nome"
        labelId="nome"
        type="text"
        value={dados.nome}
        onChange={(value) => {
          atualizarDadosPreCadastro({ nome: value });
        }}
        required
        column
        maxLength={99}
      />

      <InputLabelSelect
        labelText="UF de Nascimento"
        labelId="ufID"
        value={dados.ufID}
        onChange={(value) => {
          atualizarDadosPreCadastro({
            ufID: value,
            cidadeID: undefined,
          });

          if (value) {
            buscarCidades(value);
          }
        }}
        required
        options={
          dadosIniciais
            ? [
                { ID: "Na", Nome: " (( SELECIONAR )) " },
                ...dadosIniciais.ListaUF,
              ].map((item) => {
                return {
                  value: item.ID,
                  label: item.Nome,
                };
              })
            : []
        }
        column
      />

      <InputLabelSelect
        labelText="Cidade de Nascimento"
        labelId="cidadeID"
        value={dados.cidadeID}
        disabled={
          !dados.ufID || dados.ufID === "Na" || listaCidades.length === 0
        }
        onChange={(value) => {
          atualizarDadosPreCadastro({ cidadeID: Number(value) });
        }}
        required
        options={
          listaCidades
            ? listaCidades.map((item) => {
                return {
                  value: item.ID,
                  label: item.Nome,
                };
              })
            : []
        }
        column
      />

      <InputLabelSelect
        labelText="Sexo"
        labelId="sexoID"
        value={dados.sexoID}
        onChange={(value) => {
          atualizarDadosPreCadastro({ sexoID: Number(value) });
        }}
        required
        options={
          dadosIniciais
            ? dadosIniciais.ListaSexo.map((item) => {
                return {
                  value: item.ID,
                  label: item.Nome,
                };
              })
            : []
        }
        column
      />

      <InputLabelSelect
        labelText="Estado Civil"
        labelId="estadoCivilID"
        value={dados.estadoCivilID}
        onChange={(value) => {
          atualizarDadosPreCadastro({ estadoCivilID: Number(value) });
        }}
        required
        options={
          dadosIniciais
            ? dadosIniciais.ListaEstadoCivil.map((item) => {
                return {
                  value: item.ID,
                  label: item.Nome,
                };
              })
            : []
        }
        column
      />

      <InputLabelSelect
        labelText="Grau de Instrução"
        labelId="grauInstrucaoID"
        value={dados.grauInstrucaoID}
        onChange={(value) => {
          atualizarDadosPreCadastro({ grauInstrucaoID: Number(value) });
        }}
        required
        options={
          dadosIniciais
            ? dadosIniciais.ListaGrauInstrucao.map((item) => {
                return {
                  value: item.ID,
                  label: item.Nome,
                };
              })
            : []
        }
        column
      />

      <InputLabelSelect
        labelText="Regime de Comunhão"
        labelId="regimeComunhaoID"
        value={dados.regimeComunhaoID}
        onChange={(value) => {
          atualizarDadosPreCadastro({ regimeComunhaoID: Number(value) });
        }}
        options={
          dadosIniciais
            ? dadosIniciais.ListaRegimeComunhao.map((item) => {
                return {
                  value: item.ID,
                  label: item.Nome,
                };
              })
            : []
        }
        column
      />

      <InputLabelSelect
        labelText="Tipo Sanguíneo"
        labelId="tipoSanguineoID"
        value={dados.tipoSanguineoID}
        onChange={(value) => {
          atualizarDadosPreCadastro({ tipoSanguineoID: Number(value) });
        }}
        options={
          dadosIniciais
            ? dadosIniciais.ListaTipoSanguineo.map((item) => {
                return {
                  value: item.ID,
                  label: item.Nome,
                };
              })
            : []
        }
        column
      />

      <InputLabel
        labelText="Nome do Pai"
        labelId="pai"
        type="text"
        value={dados.pai}
        onChange={(value) => {
          atualizarDadosPreCadastro({ pai: value });
        }}
        column
        maxLength={99}
      />

      <InputLabel
        labelText="Nome da Mãe"
        labelId="mae"
        type="text"
        value={dados.mae}
        onChange={(value) => {
          atualizarDadosPreCadastro({ mae: value });
        }}
        required
        column
        maxLength={99}
      />

      <InputLabel
        labelText="RG"
        labelId="rg"
        type="number"
        value={dados.rg}
        onChange={(value) => {
          atualizarDadosPreCadastro({ rg: value });
        }}
        required
        column
        maxLength={49}
      />

      <InputLabelSelect
        labelText="UF de Expedição"
        labelId="ufIDOrgaoExpedidor"
        value={dados.ufIDOrgaoExpedidor}
        onChange={(value) => {
          atualizarDadosPreCadastro({ ufIDOrgaoExpedidor: value });
        }}
        required
        options={
          dadosIniciais
            ? [
                { ID: "", Nome: " (( SELECIONAR )) " },
                ...dadosIniciais.ListaUF,
              ].map((item) => {
                return {
                  value: item.ID,
                  label: item.Nome,
                };
              })
            : []
        }
        column
      />

      <InputLabelSelect
        labelText="Orgão Expedidor"
        labelId="orgaoExpedidorID"
        value={dados.orgaoExpedidorID}
        onChange={(value) => {
          atualizarDadosPreCadastro({ orgaoExpedidorID: Number(value) });
        }}
        required
        options={
          dadosIniciais
            ? dadosIniciais.ListaOrgaoExpedidor.map((item) => {
                return {
                  value: item.ID,
                  label: item.Nome,
                };
              })
            : []
        }
        column
      />

      <InputLabel
        labelText="Data de Expedição"
        labelId="dataExpedicaoRG"
        type="date"
        value={dados.dataExpedicaoRG}
        onChange={(value) => {
          atualizarDadosPreCadastro({ dataExpedicaoRG: value });
        }}
        required
        column
      />

      <InputLabel
        labelText="Titulo de Eleitor"
        labelId="tituloEleitor"
        type="number"
        value={dados.tituloEleitor}
        onChange={(value) => {
          atualizarDadosPreCadastro({ tituloEleitor: value });
        }}
        required
        column
        maxLength={20}
      />

      <InputLabel
        labelText="Pis/Pasep"
        labelId="pispasep"
        mask="999.99999.99-9"
        type="number"
        value={dados.pispasep}
        onChange={(value) => {
          atualizarDadosPreCadastro({ pispasep: value });
        }}
        required={dadosIniciais ? dadosIniciais.PisObrigatorio : true}
        column
        maxLength={25}
      />
    </DivisoriaSecao>
  );
}

export default DadosPessoaisPreCadastro;
